import type { ModuloWeb } from '../../nucleo/modulos-web';
import { Broadcasts } from './Broadcasts';
import { buscaAutomacoes } from './busca-global';
import { EditorFluxo } from './EditorFluxo';
import { FichaBroadcast } from './FichaBroadcast';
import { FichaAutomacao } from './Ficha';
import { Fluxos } from './Fluxos';
import { Feriados } from './Feriados';
import { Painel } from './Painel';
import { i18n } from './i18n';

/**
 * FUN 2026-10-15 (U7): Automações, a central dos robôs do servidor Windows. Painel (radar do mês e um cartão por automação),
 * ficha da automação (Fluxo, Execuções, Pendências, Configuração) e o calendário de feriados.
 */
const modulo: ModuloWeb = {
  slug: 'automacoes',
  menu: 'automacoes',
  ordem: 10,
  abas: [
    { chave: 'painel', permissao: 'automacoes.ver', componente: Painel },
    { chave: 'feriados', permissao: 'automacoes.ver', componente: Feriados },
    // U14 F1: automações de conversa (fluxos do Instagram e do WhatsApp em canvas).
    { chave: 'fluxos', permissao: 'automacoes.ver', componente: Fluxos },
    // U14 F5: Broadcast (disparo de template do WhatsApp para um público, com relatório).
    { chave: 'broadcast', permissao: 'automacoes.ver', componente: Broadcasts },
  ],
  rotasExtras: [
    { caminho: 'automacao/:id', componente: FichaAutomacao },
    { caminho: 'fluxo/:id', componente: EditorFluxo },
    { caminho: 'disparo/:id', componente: FichaBroadcast },
  ],
  i18n,
  buscaGlobal: buscaAutomacoes,
};

export default modulo;
